import { styled } from '@mui/system';
import { TextField } from '@mui/material';

const BaseTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  marginBottom: '20px',
  fontFamily: 'Playfair Display, serif',

  '& label': {
    color: '#c2b8c2',
    fontFamily: 'Cormorant Garamond, serif',
    fontSize: '1rem',
  },

  '& label.Mui-focused': {
    color: '#ffbfe5',
  },

  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '12px',
    padding: '0',
    color: '#f0f0f0',

    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },

    '&:hover fieldset': {
      borderColor: '#ffbfe5',
    },

    '&.Mui-focused fieldset': {
      borderColor: '#ffbfe5',
      boxShadow: '0 0 8px rgba(255, 191, 229, 0.3)',
    },

    '& .MuiInputBase-input': {
      lineHeight: '1',
      paddingTop: '14px',
      paddingBottom: '10px',
    },
  },

  '& input': {
    padding: '12px',
    fontFamily: 'Playfair Display, serif',
    fontSize: '1.1rem',
  },

  '& input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 0.05) inset',
    WebkitTextFillColor: '#fff',
    fontWeight: 'bold',
  },

  '& input:-webkit-autofill, \
   & input:-webkit-autofill:hover, \
   & input:-webkit-autofill:focus, \
   & input:-webkit-autofill:active': {
    WebkitBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 0.05) inset',
    WebkitTextFillColor: '#fff',
    fontWeight: 'bold',
    transition: 'background-color 5000s ease-in-out 0s',
  },

  // 🔽 Responsive adjustment for smaller screens
  '@media (max-width: 380px)': {
    marginBottom: '10px',
  },
}));

export default BaseTextField;
